import { defineFurniture } from './types.js';

/**
 * Hire-able staff NPCs. Each is a small post/stand you place like any other
 * item; the server spawns a live NPC beside it that wanders a short leash
 * from that spot (see `spawnsStaff` and `StaffNpcManager`). Picking the item
 * back up removes the NPC.
 */
export const STAFF_FURNITURE = defineFurniture('staff', {
  bodyguard_post: {
    label: 'Bodyguard',
    description: 'Hire a bodyguard to stand watch by your door. Purely for show -- he just looks intimidating.',
    price: 2200,
    solid: false,
    height: 1,
    spawnsStaff: 'bodyguard',
  },
  bar_manager_post: {
    label: 'Bar Manager',
    description: 'Hire a bar manager to keep an eye on the counter and chat with your guests.',
    price: 1800,
    solid: false,
    height: 1,
    spawnsStaff: 'bar_manager',
  },
  lifeguard_post: {
    label: 'Lifeguard',
    description: 'Hire a lifeguard to patrol your poolside, whistle at the ready.',
    price: 1800,
    solid: false,
    height: 1,
    spawnsStaff: 'lifeguard',
  },
  stadium_coach_post: {
    label: 'Stadium Coach',
    description: 'Hire a coach to pace the track and cheer on anyone who runs past.',
    price: 1800,
    solid: false,
    height: 1,
    spawnsStaff: 'stadium_coach',
  },
});
